<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">

          <form [formGroup]="ServiceRequestForm" (ngSubmit)="UpdateSR()">
            <div class="card-header card-header-danger">
              <div class="row">
                <div class="col-md-6">
                  <h4>Service Request - {{ServiceRequestForm.get('SRNumber').value}}</h4>
                </div>
                <div class="col-md-6" style="text-align: right;">
                  <i class="fa fa-paperclip" style="font-size:14px; cursor: pointer" (click)="Attachment.click()">
                    <button type="button" #Attachment style="display:none;" (click)="openFileUploadDialog()"></button>
                  </i>
                  &nbsp;&nbsp;
                  <button type="Submit" class="btn-primary1" *ngIf="IsButtonHideReOpen">Re-Open</button>
                  <button type="Submit" class="btn-primary1" *ngIf="IsButtonHide">Update</button>
                  <button type="button" class="btn-primary1" (click)="_commonService.Exit()">Exit</button>
                </div>
              </div>


            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label><span>Number</span></label></div>
                    <div class="col-md-8"> <input class="form-control" [readonly]="true" formControlName="SRNumber">
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label>Status</label></div>
                    <div class="col-md-8">
                      <p-dropdown [options]="statusList" [readonly]="true" placeholder="--Select--"
                        formControlName="StatusID" filter="true" (onChange)="GetStatusName($event)">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label
                        class="control-label">Requester</label></div>
                    <div class="col-md-8">
                      <input class="form-control" [readonly]="true" formControlName="RequestedBy">
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label>Priority</label></div>
                    <div class="col-md-8">
                      <p-dropdown [options]="priorityList" [readonly]="true" placeholder="--Select--"
                        formControlName="PriorityID" filter="true" (onChange)="GetpriorityName($event)">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="control-label">Requester
                        GPN</label></div>
                    <div class="col-md-8"> <input [readonly]="true" class="form-control"
                        formControlName="RequestedByGPN"></div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label>Category</label></div>
                    <div class="col-md-8">
                      <p-dropdown [options]="categoryList" [readonly]="true" placeholder="--Select--"
                        formControlName="CategoryId" filter="true" (onChange)="GetSubCategoryName($event)">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="control-label">Requester
                        Phone</label></div>
                    <div class="col-md-8"> <input class="form-control" [readonly]="true"
                        formControlName="RequestedByCUG"></div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label>Sub Category</label></div>
                    <div class="col-md-8">
                      <p-dropdown [options]="subcategoryList" [readonly]="true" placeholder="--Select--"
                        formControlName="SubCategoryId" filter="true" (onChange)="BindItemName($event)">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="control-label">Requested For
                        other</label></div>
                    <div class="col-md-8">
                      <mat-checkbox class="example-margin" formControlName="IsRequestedFor"
                        [checked]="ServiceRequestForm.controls.IsRequestedFor.value" [disabled]="true">
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label>Item</label></div>
                    <div class="col-md-8">
                      <p-dropdown [options]="itemList" [readonly]="true" placeholder="--Select--"
                        formControlName="ItemId" filter="true" (onChange)="BindAssigmentGroup($event)">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="control-label">Requested
                        For</label></div>
                    <div class="col-md-8"> <input class="form-control" [readonly]="true" formControlName="RequestedFor">
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label>Assignment Group</label></div>
                    <div class="col-md-8">
                      <p-dropdown [options]="assingmentGroupList" [readonly]="true" placeholder="--Select Service--"
                        filter="true" formControlName="AssignmentGroupID">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="control-label">
                        Requested for phone</label></div>
                    <div class="col-md-8"> <input class="form-control" [readonly]="true"
                        formControlName="RequestedForCUG"></div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">

                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label
                        class="control-label">Location</label></div>
                    <div class="col-md-8">
                      <p-dropdown [readonly]="true" [options]="locationList" [readonly]="true" placeholder="--Select--"
                        formControlName="ReqLocation" filter="true">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">

                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-2">
                  <div class="row">
                    <div class="col-md-12 control-label paddingforRightlabel"> <label class="control-label">Short
                        Description</label></div>


                  </div>
                </div>
                <div class="col-md-10">
                  <div class="row">

                    <div class="col-md-12"> <input class="form-control" [readonly]="true"
                        formControlName="ShortDescription"></div>

                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-2">
                  <div class="row">
                    <div class="col-md-12 control-label paddingforRightlabel"> <label
                        class="control-label">Description</label></div>


                  </div>
                </div>
                <div class="col-md-10">
                  <div class="row">

                    <div class="col-md-12"> <textarea class="form-control" [readonly]="true"
                        formControlName="LongDescription"></textarea>
                    </div>

                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-2">
                  <div class="row">
                    <div class="col-md-12 control-label paddingforRightlabel"> <label class="control-label">Add new
                        comment</label></div>


                  </div>
                </div>
                <div class="col-md-10">
                  <div class="row">

                    <div class="col-md-12"> <textarea class="form-control"
                        formControlName="AdditionalComment"></textarea> </div>

                  </div>
                </div>
              </div>

              <div class="clearfix"></div>
              <fieldset style="width: 101%;">
                <legend>Notes</legend>
                <div class="container-fluid">

                  <div class="row" style="margin-top: -25px;" *ngFor='let item of ServiceRequestLogDetailList'>

                    <div class="col-md-12">
                      <ul class="h-card-wrapper activities-form">
                        <li class="h-card h-card_md h-card_comments" style="margin-left: 130px;width: 85%;"
                          *ngIf="item.Type=='Field changes'">
                          <div
                            class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                            <span class="sn-card-component-createdby">{{item.CreatedByName}}</span>
                          </div>
                          <div class="sn-card-component sn-card-component_first sn-card-component_meta">
                            <span class="sn-card-component-time"><span> {{item.Type}}</span>
                              <span class="sn-card-component_accent-bar_bullet">•</span>
                              <div class="date-calendar">{{item.CreatedOn}}</div>
                            </span>
                          </div>
                          <div class="sn-card-component sn-card-component_records">
                            <div class="sn-widget">
                              <ul class="sn-widget-list sn-widget-list-table">
                                <li><span class="sn-widget-list-table-cell">{{item.FieldName}}</span><span
                                    class="sn-widget-list-table-cell"><span> {{item.LogText}} </span>
                                  </span></li>
                              </ul>
                            </div>
                          </div>

                        </li>

                        <li class="h-card h-card_md h-card_comments" style="margin-left: 130px;width: 85%;"
                          *ngIf="item.Type=='Email Sent'">
                          <div
                            class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                            <span class="sn-card-component-createdby">system</span>
                          </div>
                          <div class="sn-card-component sn-card-component_first sn-card-component_meta"><span
                              class="sn-card-component-time"><span>Email sent</span><span
                                class="sn-card-component_accent-bar_bullet">•</span>
                              <div class="date-calendar">{{item.CreatedOn}}</div>
                            </span></div>
                          <div class="sn-card-component sn-card-component_records">
                            <div class="sn-widget">
                              <ul class="sn-widget-list sn-widget-list-table">
                                <li><span class="sn-widget-list-table-cell"><span class="icon-mail"></span></span><span
                                    class="sn-widget-list-table-cell">Email sent</span></li>
                                <li><span class="sn-widget-list-table-cell">Subject:</span><span
                                    class="sn-widget-list-table-cell">{{item.MailSubject}}</span></li>
                                <li><span class="sn-widget-list-table-cell">From:</span><span
                                    class="sn-widget-list-table-cell">EY Help Desk</span></li>
                                <li><span class="sn-widget-list-table-cell">To:</span><span
                                    class="sn-widget-list-table-cell">{{item.MailTo}}</span></li>
                              </ul>
                            </div>
                          </div>
                          <div class="sn-card-component sn-card-component_summary sn-card-component_summary_spacing"
                            id="activity_84261326dbd23c9429efaa484b961969" [innerHTML]="item.LogText">
                            <div class="sn-widget sn-widget-textblock"></div>
                          </div>

                        </li>
                        <li class="h-card h-card_md h-card_comments" style="margin-left: 130px;width: 85%;"
                          *ngIf="item.Type=='Work notes'">
                          <div
                            class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                            <span class="sn-card-component-createdby">{{item.CreatedByName}}</span>
                          </div>
                          <div class="sn-card-component sn-card-component_first sn-card-component_meta">
                            <span class="sn-card-component-time"><span>{{item.Type}}</span><span
                                class="sn-card-component_accent-bar_bullet">•</span>
                              <div class="date-calendar">{{item.CreatedOn}}</div>
                            </span>
                          </div>
                          <div class="sn-card-component sn-card-component_summary sn-card-component_summary_spacing"
                            id="activity_6fa7cb6edb52fc5c088caa484b961983">
                            <div class="sn-widget sn-widget-textblock state-expanded">
                              <span class="sn-widget-textblock-body sn-widget-textblock-body_formatted">{{item.LogText}}
                              </span>
                            </div>
                          </div>
                        </li>

                        <li class="h-card h-card_md h-card_comments" style="margin-left: 130px;width: 85%;"
                          *ngIf="item.Type=='Attachment'">
                          <div
                            class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                            <span class="sn-card-component-createdby">{{item.CreatedByName}}</span>
                          </div>
                          <div class="sn-card-component sn-card-component_first sn-card-component_meta">
                            <span class="sn-card-component-time"><span>{{item.Type}}</span><span
                                class="sn-card-component_accent-bar_bullet">•</span>
                              <div class="date-calendar">{{item.CreatedOn}}</div>
                            </span>
                          </div>
                          <div class="sn-card-component sn-card-component_summary sn-card-component_summary_spacing"
                            id="activity_6fa7cb6edb52fc5c088caa484b961983">
                            <div class="sn-widget sn-widget-textblock state-expanded">
                              <span class="sn-widget-textblock-body sn-widget-textblock-body_formatted">{{item.LogText}}
                              </span>
                            </div>
                          </div>
                        </li>

                        <li class="h-card h-card_md h-card_comments" style="margin-left: 130px;width: 85%;"
                          *ngIf="item.Type=='Delete'">
                          <div
                            class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                            <span class="sn-card-component-createdby">{{item.CreatedByName}}</span>
                          </div>
                          <div class="sn-card-component sn-card-component_first sn-card-component_meta">
                            <span class="sn-card-component-time"><span>{{item.Type}}</span><span
                                class="sn-card-component_accent-bar_bullet">•</span>
                              <div class="date-calendar">{{item.CreatedOn}}</div>
                            </span>
                          </div>
                          <div class="sn-card-component sn-card-component_summary sn-card-component_summary_spacing"
                            id="activity_6fa7cb6edb52fc5c088caa484b961983">
                            <div class="sn-widget sn-widget-textblock state-expanded">
                              <span class="sn-widget-textblock-body sn-widget-textblock-body_formatted">{{item.LogText}}
                              </span>
                            </div>
                          </div>
                        </li>
                      </ul>

                    </div>
                  </div>

                </div>
              </fieldset>

            </div>

          </form>



        </div>
      </div>

    </div>
  </div>
</div>